import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Close mobile sidebar when resizing to desktop
      if (!mobile) {
        setSidebarMobileOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    console.log('Toggle sidebar clicked', { isMobile, sidebarMobileOpen });
    if (isMobile) {
      setSidebarMobileOpen(!sidebarMobileOpen);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const closeMobileSidebar = () => {
    setSidebarMobileOpen(false);
  };

  return (
    <div className="layout">
      <Sidebar 
        collapsed={sidebarCollapsed}
        mobileOpen={sidebarMobileOpen}
        onToggle={toggleSidebar}
        onClose={closeMobileSidebar}
        isMobile={isMobile}
      />
      
      <div className={`layout-main ${sidebarCollapsed && !isMobile ? 'collapsed' : ''}`}>
        <Header 
          onMenuClick={toggleSidebar}
          isMobile={isMobile}
        />
        <main className="layout-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;